import useMediaQuery from "@mui/material/useMediaQuery";
import { tokens } from "./tokens";

/** The kit's one phone breakpoint: below `tokens.breakpoint.phone` (760). SCSS repeats it as `(max-width: 759px)`. */
export const PHONE_QUERY = `(max-width: ${tokens.breakpoint.phone - 1}px)`;

/** True on a phone-width screen. Every new page and kit piece uses this, never its own media query string. */
export const usePhone = (): boolean => useMediaQuery(PHONE_QUERY);
